import React, { useRef } from 'react'
import { Know, Know as KnowInterface, KnowTranscript } from 'interfaces/Know'
import { useRouter } from 'next/router'
import { AnalyticsEventKnowSubjectsSectionImpression } from 'lib/constants/AnalyticsEventType'
import { getReferrerScreen } from 'lib/formatting/url'
import Stack from 'components/elements/Stack'
import { ContainerMain } from 'components/layouts/Layouts.css'
import theme from 'stories/utils/theme'
import { Flashcard } from 'interfaces/Flashcard'
import useImpressionTracking from 'lib/hooks/useImpressionTracking'
import { KnowSeoInfo } from 'interfaces/KnowSeoInfo'
import AIEnhancedPNGPreview from './PNGPreview/AiEnhanced/AIEnhancedPNGPreview'
import { ActiveExperiments } from 'lib/features/activeExperiments'

interface Props {
    know: Know
    transcript: KnowTranscript | null
    similarKnows: KnowInterface[] | null
    flashcards?: Flashcard[] | null
    knowSeoInfo: KnowSeoInfo | null
    unblurContentForSmallerMarkets: boolean
    experiments: ActiveExperiments
}

const MobileKnowSEOSection = ({
    know,
    transcript,
    similarKnows,
    flashcards,
    knowSeoInfo,
    unblurContentForSmallerMarkets,
    experiments,
}: Props) => {
    const router = useRouter()
    const referrerScreen = getReferrerScreen(router)
    const knowSubjectsRef = useRef<HTMLDivElement>(null)

    useImpressionTracking(knowSubjectsRef, AnalyticsEventKnowSubjectsSectionImpression, { referrerScreen, know })

    if (!know || !knowSeoInfo) return null

    return (
        <ContainerMain backgroundColor={theme.colors.white}>
            <Stack>
                <AIEnhancedPNGPreview
                    knowSeoInfo={knowSeoInfo}
                    isMobile
                    transcript={transcript}
                    flashcards={flashcards}
                    similarKnows={similarKnows}
                    unblurContentForSmallerMarkets={unblurContentForSmallerMarkets}
                    experiments={experiments}
                />
            </Stack>
        </ContainerMain>
    )
}

export default MobileKnowSEOSection
